import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

function Unauthorized() {
  const history = useHistory();

  useEffect(() => {
    // Log para debug (apenas console)
    console.warn("Acesso negado - Redirecionado para página Unauthorized");
  }, []);

  const handleGoHome = () => {
    history.push("/");
  };

  return (
    <Container>
      <Content>
        <IconWrapper>
          <LockOutlinedIcon style={{ fontSize: 80 }} />
        </IconWrapper>

        <Title>Acesso Negado</Title>

        <Message>
          Você não tem autorização para acessar este recurso.
        </Message>

        <HelpText>
          Se você acredita que deveria ter acesso a este recurso, entre em contato com o administrador do sistema.
        </HelpText>

        <ButtonGroup>
          <HomeButton onClick={handleGoHome}>
            Voltar para Página Principal
          </HomeButton>
        </ButtonGroup>
      </Content>
    </Container>
  );
}

export default Unauthorized;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

// Styled Components
const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  font-family: "Mulish", sans-serif;
`;

const Content = styled.div`
  background: white;
  border-radius: 24px;
  padding: 3rem 2.5rem;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.6s ease;
  text-align: center;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const IconWrapper = styled.div`
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #fef3c7 0%, #fca5a5 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  color: #dc2626;
  animation: ${pulse} 2s ease-in-out infinite;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 1rem 0;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #64748b;
  margin: 0 0 2rem 0;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const HelpText = styled.p`
  font-size: 0.9rem;
  color: #94a3b8;
  margin: 0 0 2rem 0;
  line-height: 1.5;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const HomeButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Mulish", sans-serif;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;
